<script setup lang="ts">
import MobileViewDropdown from '@components/StickyTabs/MobileViewDropdown.vue';
import { computed, ref, watch } from 'vue';
import { trans } from '@tools/translation';
import { ViewType } from '@components/StickyTabs/map-constants';

const { currentView } = defineProps<{
  currentView: ViewType;
}>();

const emit = defineEmits<{(event: 'set-view', view: ViewType): void }>();

const viewOptions = new Map<ViewType, string>([
  [ ViewType.LIST, trans('mobile.view.option.list') ],
  [ ViewType.MAP, trans('mobile.view.option.map') ],
]);

const view = ref<ViewType>(currentView);

watch(view, (value: ViewType): void => {
  emit('set-view', value as ViewType);
});
</script>

<template>
  <div class="sticky-tabs !bottom-[90px]">
    <MobileViewDropdown
      v-model="view"
      :options="viewOptions"
    />
  </div>
</template>
